import { render, staticRenderFns } from "./RejectionInfo.vue?vue&type=template&id=ee0a68c2&scoped=true&"
import script from "./RejectionInfo.vue?vue&type=script&lang=js&"
export * from "./RejectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./RejectionInfo.vue?vue&type=style&index=0&id=ee0a68c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a68c2",
  null
  
)

export default component.exports